import { fetchJson } from "./aor-jsonapi-client/fetch";
import jsonAPIRestClient from "./aor-jsonapi-client/restClient";

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/vnd.api+json" });
  }
  options.headers.set("Authorization", process.env.REACT_APP_AUTH_HEADER);
  options.headers.set("X-Source", "crm");

  const token = localStorage.getItem("token");
  if (token) {
    options.headers.append("Authorization", "Bearer " + token);
  }

  return fetchJson(url, options);
};



const uploadImage = rawFile => {
  var formData  = new FormData();
  formData.append('image', rawFile);
  const headers = new Headers({ Accept: "application/json" });

  headers.set("Authorization", process.env.REACT_APP_AUTH_HEADER);
  const token = localStorage.getItem("token");
  
  if (token) {
    headers.append("Authorization", "Bearer " + token);
  }

  return fetch(`${process.env.REACT_APP_API_URL}/assets/img`, {
    method: "POST",
    headers,
    body: formData
  }).then(response => {
    if(response.status < 200 || response.status >= 300) {
      throw new Error('Image upload failed.');
    }

    return response.json().then(resp => resp.filename);
  })
}

const restClient = jsonAPIRestClient(process.env.REACT_APP_API_URL, httpClient);

const getSrc = (filename) => `${process.env.REACT_APP_API_URL}/assets/img/${filename}`

const getImage = (filename, title) => ({
  src: `${process.env.REACT_APP_API_URL}/assets/img/${filename}`,
  title
})

const addUploadCapabilities = requestHandler => (type, resource, params) => {
  if (type === "UPDATE" && resource === "marketing_partners") {
    const logo = params.data.web_offer_style.logo;
    if (Array.isArray(logo) && logo.length === 1) {
      return uploadImage(logo[0].rawFile).then(filename => {
        const transformed = {
          ...params,
          data: {
              ...params.data,
              web_offer_style: {
                ...params.data.web_offer_style,
                logo: getImage(filename)
              }
          },
        }
        return restClient(type, resource, transformed)
      })
    } else {
      return restClient(type, resource, params);
    }
  }
  else if ((type === "CREATE" || type === "UPDATE")) {

    const pImages = params.data.images;
    const imagesAsObject = ( !Array.isArray(pImages) )
    if (pImages && (pImages.length || Object.keys(pImages).length )) {

      let images = []

      if ( imagesAsObject ) {
        images = Object.keys(pImages).map((imgName) => {
          const img = pImages[imgName][0] || pImages[imgName]
          return {
            src: img.src,
            rawFile: img.rawFile,
            title: imgName
          }
        })
      } else {
        images = pImages
      }

      const formerPictures = images.filter(p => !(p.rawFile instanceof File));
      const newPictures = images.filter(p => p.rawFile instanceof File);

      return Promise.all(newPictures.map((p) => uploadImage(p.rawFile).then((filename) => ({filename: filename,title: p.title}))))
          .then(uploadedImages => {
            if (imagesAsObject) {
              uploadedImages.forEach(uploadedImage => {
                uploadedImage.src = `${getSrc(uploadedImage.filename)}`
              })
              return uploadedImages
            } else {
              return uploadedImages.map(uploadedImage => getImage(uploadedImage.filename, `${params.data.title}`));
            }

          })

          .then(transformedUploadedImages => {
            if (imagesAsObject) {
              const transformedImages = {}
              transformedUploadedImages.forEach((img) => {
                transformedImages[img.title]  = {
                  src: img.src,
                  title: img.title
                }
              })
              formerPictures.forEach((img) => {
                transformedImages[img.title]  = {
                  src: img.src,
                  title: img.title
                }
              })

              return restClient(type, resource, {
                ...params,
                data: {
                  ...params.data,
                  images: transformedImages
                }
              })
            } else {
              return restClient(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    images: [...transformedUploadedImages, ...formerPictures],
                },
              })
            }
          });
    }
  }

  return restClient(type, resource, params);
};







export default addUploadCapabilities(restClient);



// WEBPACK FOOTER //
// ./src/restClient.js